import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";
import { getWebUrl } from "@ui/../config/src";
import { ButtonLink } from "@ui/components/button";
import { useSearchResultQueryParams } from "@ui/components/search/hooks/use-query-params";
import Link from "next/link";
import { Modal, Modal_T } from "../modal";

export interface ReportRedirectModalProps extends Modal_T {
  onFreeClick: () => void;
  onPremiumClick: () => void;
}

export const ReportRedirectModal = (props: ReportRedirectModalProps) => {
  const { isOpen, onClose, onFreeClick, onPremiumClick } = props;
  const { getSearchResult } = useSearchResultQueryParams();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Heading color="blue.500" size="xl">
        Check Out AreaHub Pro or Run A Limited Free Report
      </Heading>
      <Text display={{ base: "none", sm: "block" }} fontSize="md">
        Looking for a detailed, <strong>address-specific report</strong>?
        Explore{" "}
        <strong>
          <Link
            style={{ color: "black" }}
            href={getWebUrl() + "/individuals/pricing"}
          >
            AreaHub Pro
          </Link>
        </strong>
        , starting at only $24.99. Gain access to over 20 topics, hazard
        insights, and interactive maps.
        <br />
        <Box mt={3}>
          For a free, more limited report, we can provide information{" "}
          <strong>based on the nearest major U.S. city</strong> to{" "}
          {getSearchResult()}.
        </Box>
      </Text>

      <Flex
        flexDirection={{
          base: "column",
          sm: "row",
        }}
        gap={{
          base: "24px",
          sm: "24px",
        }}
      >
        <ButtonLink
          bgColor="blue.500"
          color="white"
          borderRadius="full"
          href={getWebUrl() + "/individuals/pricing"}
          onClick={onPremiumClick}
        >
          Check Out AreaHub Pro
        </ButtonLink>
        <Button
          bgColor="green.600"
          color="white"
          borderRadius="full"
          onClick={onFreeClick}
        >
          Continue to Free Report
        </Button>
      </Flex>
    </Modal>
  );
};
